import React, { useState, useEffect } from 'react';
import './Navbar.css'; // We'll keep all styles in this CSS file
import Logo from '../../../Assert/Image/oldlogo.png';
const Footer = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // Toggle body scroll when menu opens/closes
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
    // Cleanup
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  // Initialize AOS (simple scroll animations) – include the library via CDN in public/index.html
  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({
        duration: 900,
        once: true,
        offset: 120,
        easing: 'ease-out-quad'
      });
    }
  }, []);

  // Pulse effect interval (optional)
  useEffect(() => {
    const interval = setInterval(() => {
      const badges = document.querySelectorAll('.badge');
      badges.forEach((badge, index) => {
        if (index % 3 === 0) {
          badge.classList.toggle('pulse');
        }
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const toggleMenu = () => setMenuOpen(prev => !prev);

  return (
    <>
     

     

   

 

      {/* FOOTER (identical) */}
      <footer className="footer">
        <div className="footer-grid" data-aos="fade-up" data-aos-delay="50">
          <div className="footer-col">
            <h4>Permixcels</h4>
            <ul>
              <li><a href="#">About us</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Press</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li><a href="#">Web Dev</a></li>
              <li><a href="#">Digital Marketing</a></li>
              <li><a href="#">Design</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Connect</h4>
            <ul>
              <li><a href="#"><i className="fab fa-linkedin"></i> LinkedIn</a></li>
              <li><a href="#"><i className="fab fa-instagram"></i> Instagram</a></li>
              <li><a href="#"><i className="fab fa-behance"></i> Behance</a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">© 2025 Permixcels Technologies. All rights reserved.</div>
      </footer>
    </>
  );
};

export default Footer;